// Library Methods
import axios from "axios";

// Utils
import { config, webServiceUrl } from "src/utils/services/servicesHelper";

// Types
import { DeviceType } from "./types";

const getClinicDevices = async (
  accessToken: string,
  clinicId: string,
  signal: AbortSignal
): Promise<Array<DeviceType>> => {
  try {
    const { data } = await axios.get(
      `${webServiceUrl}/clinics/${clinicId}/devices`,
      config(accessToken, signal)
    );
    return data?.data;
  } catch (error) {
    throw error;
  }
};

const linkExamToDevice = async (
  accessToken: string,
  clinicId: string,
  deviceId: string,
  examData: { examId: string }
) => {
  try {
    const { data } = await axios.post(
      `${webServiceUrl}/clinics/${clinicId}/devices/${deviceId}/exam`,
      examData,
      config(accessToken)
    );
    return data?.data;
  } catch (error) {
    throw error;
  }
};

const unlinkExamFromDevice = async (
  accessToken: string,
  clinicId: string,
  deviceId: string
) => {
  try {
    const { data } = await axios.delete(
      `${webServiceUrl}/clinics/${clinicId}/devices/${deviceId}/exam`,
      config(accessToken)
    );
    return data?.data;
  } catch (error) {
    throw error;
  }
};

const transferDeviceToClinic = async (
  accessToken: string,
  clinicId: string,
  deviceId: string,
  targetClinicId: string
) => {
  try {
    const { data } = await axios.post(
      `${webServiceUrl}/clinics/${clinicId}/devices/${deviceId}/transfer`,
      { targetClinicId },
      config(accessToken)
    );
    return data?.data;
  } catch (error) {
    throw error;
  }
};

export {
  getClinicDevices,
  linkExamToDevice,
  unlinkExamFromDevice,
  transferDeviceToClinic,
};
